// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style_cardContainer__MS663","cardContainerList":"style_cardContainerList__3wrjb","marginVertical":"style_marginVertical__J_fY_"};